<template>
  <div>
    <Toast />
    <section
      class="row w-100 d-flex justify-content-center align-items-center height-center"
    >
      <div class="d-flex justify-content-end align-items-center col-12 steps-img">
        <img
          src="~@/assets/futuro-corp.png"
          width="200"
          alt="Futuro Corp"
        />
      </div>
      <div class="col-12 mt-5 steps-title d-flex justify-content-center">
        <span class="m-2">Está na hora de escolhermos seu plano de assinatura</span>
      </div>

      <div v-if="loadingUserResponse" class="col-12 d-flex justify-content-center align-items-center">
        <div class="loading-min">
          <i class="fas fa-spinner fa-spin" />
        </div>
      </div>
      <div v-else-if="userResponseError" class="col-12 d-flex justify-content-center align-items-center flex-column mt-4">
        <span class="error-message">Não foi possível carregar seus dados. Verifique sua conexão e tente novamente.</span>
        <button class="btn-default mt-3 btn-retry" @click="retryLoadUser">
          <i class="fas fa-redo mr-2" /> Tentar novamente
        </button>
      </div>
      <div
        v-else
        class="col-12 container-cards d-flex justify-content-center align-items-center flex-column"
      >
        <div class="box-cards">
          <aside class="cards card-monthly">
            <div class="card-top"></div>
            <div class="card-body">
              <h4>Plano Mensal</h4>
              <span>
                Ideal para organização financeira individual, 
                para uma pessoa que mora sozinha e precisa organizar as próprias finanças.
              </span>
              <div class="discount" v-if="isPnEmployee">
                <span><b>50% OFF</b> para PNS e Backoffice</span>
              </div>
              <div :class="['price', { monthly: !isPnEmployee }]">
                <template v-if="isPnEmployee">
                  <span class="old">R$ {{ monthlyBaseFormatted }}</span>
                  <span class="new">R$ {{ monthlyPriceFormatted }}</span>
                </template>
                <template v-else>
                  <span>R$ {{ monthlyPriceFormatted }}</span>
                </template>
              </div>
              <div class="card-button">
                <button
                  class="btn-default"
                  :disabled="loadingConfirmation"
                  @click="signConfirmation('monthly')"
                >
                  <span v-if="loadingConfirmation">
                    <i class="fas fa-spinner fa-spin" />
                  </span>
                  <span v-else>Assinar</span>
                </button>
              </div>
            </div>
          </aside>

          <aside class="cards card-annual">
            <div class="card-top">
              <span>Mais escolhido</span>
            </div>
            <div class="card-body">
              <h4>Plano Anual</h4>
              <span>
                Ideal para organização financeira de uma família grande, 
                e alcançar objetivos a longo prazo de todos.
              </span>

              <div class="discount" v-if="!isPnEmployee">
                <span><b>R$ 58,90</b> economizados</span>
              </div>
              <div class="discount" v-if="isPnEmployee">
                <span><b>50% OFF</b> para PNS e Backoffice</span>
              </div>
              <div class="price">
                <template v-if="isPnEmployee">
                  <span class="old">R$ {{ annualBaseFormatted }}</span>
                  <span class="new">R$ {{ annualPriceFormatted }}</span>
                </template>
                <template v-else>
                  <span>R$ {{ annualPriceFormatted }}</span>
                </template>
              </div>
              <div class="card-button">
                <button
                  class="btn-default"
                  :disabled="loadingConfirmation"
                  @click="signConfirmation('annual')"
                >
                  <span v-if="loadingConfirmation">
                    <i class="fas fa-spinner fa-spin" />
                  </span>
                  <span v-else>Assinar</span>
                </button>
              </div>
            </div>
          </aside>
        </div>
      </div>
      <Modal
        class="checkout-modal"
        :is-open="isModalOpen"
        @close="closeModal"
      >
        <div v-if="loading" class="loading-min">
          <i class="fas fa-spinner fa-spin" />
        </div>
        <template v-else>
          <div class="form-default container modal-container">
            <div class="row">
              <label>Cupom de desconto</label>
              <div class="col">
                <input
                  id="discount-coupon"
                  v-model="discountCoupon"
                  type="text"
                  name="discount-coupon"
                  class="form-control"
                  @input="discountCoupon = (discountCoupon || '').toUpperCase()"
                  @change="verifyCoupon"
                />
              </div>
            </div>
            <div class="row mt-2" v-if="discountCoupon && validCoupon !== undefined">
              <div class="discount-result">
                <span v-if="validCoupon" class="discount-valid">
                  Cupom válido com {{ couponDiscount }}% de desconto
                </span>
                <span v-else class="discount-invalid">
                  Cupom inválido ou expirado
                </span>
              </div>
            </div>
            <div class="row mt-2">
              <div class="checkbox">
                <input 
                  id="policy-accepted" 
                  type="checkbox" 
                  class="form-check-input"
                  v-model="policyTermsAccepted"
                />
                <label for="policy-accepted">
                  Aceito os 
                  <a 
                    href="https://futurogfp-assets.s3.sa-east-1.amazonaws.com/AppTermsAndConditions.pdf"
                    target="_blank" 
                    rel="noopener"
                  >
                    Termos de uso e política de privacidade
                  </a>
                </label>
              </div>
            </div>
          </div>
          <div class="form-default container modal-container">
            <div class="row">
              <div class="col d-flex justify-content-center align-items-center">
                <button
                  class="btn-default"
                  @click="createSubscription"
                  :disabled="!policyTermsAccepted || loading"
                >
                  Seguir com o pagamento
                </button>
              </div>
            </div>
          </div>
        </template>
      </Modal> 
    </section>
  </div>
</template>

<script>
import Modal from "@/components/shared/Modal.vue";
import { useAppStore } from "@/store/store.js";

export default {
  components: {
    Modal,
  },
  data() {
    return {
      loading: false,
      loadingConfirmation: false,
      planSelected: undefined,
      isModalOpen: false,
      discountCoupon: undefined,
      policyTermsAccepted: false,
      validCoupon: undefined,
      couponDiscount: 0,
      monthlyBase: 29.90,
      annualBase: 299.90,
    };
  },
  computed: {
    isSubscriber() {
      const store = useAppStore();
      return store.isSubscriberAccess() || false;
    },
    isPnEmployee() {
      const store = useAppStore();
      let user = store.userResponse?.data?.userInfo;
      return !!user?.is_pn_employee;
    },
    loadingUserResponse () {
      const store = useAppStore();
      return store.userResponse.loading;
    },
    userResponseError() {
      const store = useAppStore();
      return store.userResponse.error;
    },
    hasSignedInterview() {
      const store = useAppStore();
      return store.hasSignedInterview;
    },
    monthlyPrice() {
      return this.isPnEmployee ? this.monthlyBase / 2 : this.monthlyBase;
    },
    annualPrice() {
      return this.isPnEmployee ? this.annualBase / 2 : this.annualBase;
    },
    monthlyPriceFormatted() {
      return this.formatBRL(this.monthlyPrice);
    },
    annualPriceFormatted() {
      return this.formatBRL(this.annualPrice);
    },
    monthlyBaseFormatted() {
      return this.formatBRL(this.monthlyBase);
    },
    annualBaseFormatted() {
      return this.formatBRL(this.annualBase);
    },
  },
  mounted() {
    const store = useAppStore();
    if(!store.isFreemiumAccess() && this.isSubscriber) {
      this.$router.push({ name: "dashboard" });
    }
  },
  methods: {
    retryLoadUser() {
      const store = useAppStore();
      store.userResponse.error = false;
      store.getUser();
    },
    formatBRL(value) {
      const n = Number(value || 0);
      return n.toFixed(2).replace(".", ",");
    },

    signConfirmation(plan) {
      this.planSelected = plan;
      if(!this.hasSignedInterview){
        this.isModalOpen = true;
      } else {
        this.loadingConfirmation = true;
        this.createSubscription();
      }
    },
    createSubscription(){
      const store = useAppStore();
      this.loading = true;
      store.createSubscription({
        plan: this.planSelected,
        discount_coupon: this.discountCoupon,
      })
        .then((response) => {
          const token = response.data.customer_token;
          if(token){
            this.closeModal();
            setTimeout(() => {
              if (response.data.is_coupon_exempt) {
                this.$router.push({ name: "dashboard", query: { success: true } });
                return;
              }

              window.location.href = `${process.env.VUE_APP_INTERVIEW_FRONTEND_URL}/checkout/${token}`;
            }, 1000);
          }else{
            this.$toast.add({
              severity: "error",
              summary: "Recurso indisponível",
              detail: "Ocorreu um erro ao criar assinatura. Tente novamente ou entre em contato com o nosso suporte.",
              life: 5000,
            });
          }
        })
        .catch((error) => {
          if(error && error.response && error.response.status == 400){
            this.$toast.add({
              severity: "error",
              summary: "Recurso indisponível",
              detail: `Ocorreu um erro ao criar assinatura. ${error.response.data.message}`,
              life: 5000,
            });
          }else{
            this.$toast.add({
              severity: "error",
              summary: "Recurso indisponível",
              detail: "Ocorreu um erro ao criar assinatura. Tente novamente ou entre em contato com o nosso suporte.",
              life: 5000,
            });
          }
          this.closeModal();
        })
        .finally(() => {
          this.loading = false;
          setTimeout(() => {
            this.loadingConfirmation = false;
          }, 1000);
        });

    },
    async verifyCoupon(){
      this.loading = true;
      const store = useAppStore();
      store.verifyDiscountCoupon(this.discountCoupon)
        .then((response) => {
          const coupon = response.data;
          if(!coupon || coupon.error || coupon.percentage <= 0) {
            this.validCoupon = false;
            this.couponDiscount = 0;
          } else {
            this.validCoupon = true;
            this.couponDiscount = coupon.percentage;
          }
        })
        .catch(() => {
          this.validCoupon = false;
          this.couponDiscount = 0;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    closeModal() {
      this.isModalOpen = false;
      this.planSelected = undefined;
      this.discountCoupon = undefined;
      this.policyTermsAccepted = false;
      this.validCoupon = undefined;
      this.couponDiscount = 0;
    },
  },
}
</script>

<style lang="scss" scoped>

.steps-title {
  span {
    font-size: 2em;
    font-weight: 700;
    color: #00AD00;
  }
}

.error-message {
  color: #ff6800;
  font-size: 1em;
  text-align: center;
}

.btn-retry {
  white-space: nowrap;
  width: auto;
  padding: 0 32px;
}

.discount-valid{
  color: #00AD00;
}

.discount-invalid{
  color: #ff6800;
}

.container-cards,
.steps-img {
  margin-bottom: 5rem;
  @media (max-width: 992px) {
    margin-bottom: 3rem;
  }
}

.modal-container{
  margin: 20px auto;
  padding: 0 30px;
  button{
    width: 200px;
    
    &:disabled {
      background: #cccccc !important;
      color: #666666 !important;
      cursor: not-allowed !important;
      opacity: 0.6;
      border: 1px solid #cccccc;
      
      &:hover {
        transform: none !important;
      }
    }
  }
}

.checkbox {
  color: aliceblue;
  width: 100%;
  display: flex;
  justify-content: flex-start;
  margin: 10px;
  label{
    font-size: 14px;
    a{
      color:#ff6800
    }
  }

  input{
    margin-right: 10px;
  }
}

.form-check-input:checked {
  background-color: #ff6800;
  border-color: #ff6800;
}

.discount-result{
  .valid{
    color: #00AD00;
  }
  .invalid{
    color: #ff6800;
  }
}


.container-cards {
  .box-cards {
    gap: 2.5rem;
    display: flex;
    flex-wrap: wrap;
    width: 100%;
    justify-content: center;
    align-items: flex-end;
    padding: 2em;
    
    .card-monthly {
      background: white;
      
      .card-top{
        border-top-left-radius: 10px;
        border-top-right-radius: 10px;
        height: 21px;
        background:#283045;
      }

    }

    .card-annual {
      height: 431px !important;
      background: white;

      .card-top{
        border-top-left-radius: 10px;
        border-top-right-radius: 10px;
        height: 46px;
        background:#CB5540;
        display: flex;
        justify-content: center;
        align-items: center;
        font-weight: 700;
        color: #fff;
      }
    }

    .card-body {
      padding: 1.45em;
      flex-direction: column;
      height: 100%;
      margin-top: 10px;

      h4{
        font-weight: 700;
      }

      span {
        font-size: 16px;
      }

      .discount{
        margin-top: 50px;
        span{
          font-size: 16px;
          line-height: 18px;
          color: #00AD00;
        }
      }

      .price {
        display: flex;
        align-items: baseline;
        gap: 10px;

        span {
          font-weight: 900;
          font-size: 24px;
          line-height: 57px;
          color: #CB5540;
        }

        &.monthly{
          margin-top: 44px;
        }

        .old{
          font-weight: 600;
          font-size: 18px;
          color: #8b8b8b;
          text-decoration: line-through;
        }

        .new{
          font-weight: 900;
          font-size: 26px;
          color: #CB5540;
        }
      }

      .card-button{
        justify-content: center;
        display: flex;
        margin-top: 20px;
      }
    }

    .cards {
      width: calc(50% / 2);
      min-width: 389px;
      height: 406px;
      // max-width: 350px;
      border-radius: 12px 12px 10px 10px;

      @media (max-width: 600px) {
        width: 98%;
      }

      h1 {
        font-size: clamp(1.65em, 1.85em + 3vw, 2em);
        font-weight: bold;
        margin-bottom: 2rem;
      }

      .steps-card {
        display: flex;
        align-items: center;
        margin: 0 1rem 1.5rem 0;

        .step {
          width: 40px;
          height: 40px;
          min-width: 40px;
          display: flex;
          align-items: center;
          justify-content: center;
          border: 2px solid #fff;
          border-radius: 100%;
          background-color: #000;
          text-align: center;
          font-size: 1.25em;
          font-weight: bold;
          margin-right: 1rem;
        }

        h3 {
          font-size: clamp(1em, 1.125em + 3vw, 1.25em);
          font-weight: bold;
          margin: 0;
        }
      }
    }
  }

  .markers {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 2rem;
  }

  .marker-1,
  .marker-2 {
    display: flex;
    align-items: center;
    div {
      width: 25px;
      height: 25px;
      border-radius: 5px;
      margin-right: 1rem;
    }

    span {
      font-size: 1em;
    }
  }

  .marker-1 {
    margin-right: 1.5rem;
    div {
      background-color: rgb(65 122 201);
    }
  }

  .marker-2 {
    div {
      background-color: rgb(255 137 69);
    }
  }
}

.height-center {
  height: 100%;
  @media (max-width: 1670px) {
    height: auto;
  }
}
</style>
